import React, { useEffect, useContext, useState } from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import styles from './styles.css';
import Heading from '../../components/Typography/Heading/Heading';
import { runDebounced } from '../../flows/shared/utils';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const CreateCredentialsScreen = () => {
  const context = useContext(FlowContext);
  const { next, back, formProps, appState } = context;
  const {
    store: { authenticated }
  } = appState;

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (authenticated) {
      runDebounced(() => next()());
    }
  }, []);

  const togglePassword = () => setShowPassword(!showPassword);

  return (
    <div className="container">
      <Heading text="Create credentials to access your account" />
      <div className="credentials-wrapper">
        <div className="username-input">
          <InputField
            title="Choose a user name"
            id="usernameField"
            {...formProps.username}
            data-name={generateGeneralTestID('Credentials', 'Username')}
            className="blocked_data"
          />
        </div>
        <div className="password-input">
          <InputField
            title="Choose a password"
            type={showPassword ? 'text' : 'password'}
            id="passwordField"
            {...formProps.password}
            data-name={generateGeneralTestID('Credentials', 'Password')}
            className="blocked_data"
          />
        </div>
        <span className="toggle-pswd-btn">
          <MFBeaconButton
            id="togglePasswordbtn"
            data-name={generateGeneralTestID(
              'Credentials',
              'TogglePasswordDisplay'
            )}
            className="override-beacon-button-padding"
            type="button"
            onClick={togglePassword}
            variant="tertiary"
            label={!showPassword ? 'Show' : 'Hide'}
          />
        </span>
      </div>

      <div className="button-container">
        <MFBeaconButton
          id="createCredentialsContinue"
          data-name={generateGeneralTestID('Credentials', 'ContinueButton')}
          className="continue-btn"
          variant="primary"
          size="normal"
          onClick={next()}
          label="Continue"
        />
        <MFBeaconButton
          id="createCredentialsBack"
          data-name={generateGeneralTestID('Credentials', 'BackButton')}
          variant="secondary"
          className="beacon-button-margin-override"
          size="normal"
          onClick={back()}
          label="Back"
        />
      </div>
      <PhoneNumber />
      <style jsx>{styles}</style>
    </div>
  );
};

export default CreateCredentialsScreen;
